export default (string: String): String =>
  string.charAt(0).toUpperCase() + string.slice(1);
